import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.stepAppsureBankDetails.sectionTitle',
    defaultMessage: 'Section 10 - Bank Details',
  },
  whatIsYourABN: {
    id: 'fastCover.stepAppsureBankDetails.whatIsYourABN',
    defaultMessage: 'What is your Australian Business Number (ABN)?',
  },
  claimITC: {
    id: 'fastCover.stepAppsureBankDetails.claimITC',
    defaultMessage: 'Have you claimed or are you entitled to claim an Input Tax Credit (ITC) in respect to the GST paid on the insurance policy under which this claim is being made?',
  },
  whatPercentageOfGST: {
    id: 'fastCover.stepAppsureBankDetails.whatPercentageOfGST',
    defaultMessage: 'What percentage of GST did you claim or are entitled to claim?',
  },
  yes: {
    id: 'fastCover.stepAppsureBankDetails.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.stepAppsureBankDetails.no',
    defaultMessage: 'No',
  },
  weCannotDepositIntoACreditCardAccount: {
    id: 'fastCover.stepAppsureBankDetails.weCannotDepositIntoACreditCardAccount',
    defaultMessage: 'We cannot deposit into a credit card account or overseas bank account.',
  },
  paymentRequiredMessage: {
    id: 'fastCover.stepAppsureBankDetails.paymentRequiredMessage',
    defaultMessage: 'If we are required to make a payment on your behalf, no payment will be made until we receive payment from you of any applicable excess.',
  },
  nameOfBank: {
    id: 'fastCover.stepAppsureBankDetails.nameOfBank',
    defaultMessage: 'Name of Bank',
  },
  branch: {
    id: 'fastCover.stepAppsureBankDetails.branch',
    defaultMessage: 'Branch Name',
  },
  bsbNumber: {
    id: 'fastCover.stepAppsureBankDetails.bsbNumber',
    defaultMessage: 'BSB Code',
  },
  accountNumber: {
    id: 'fastCover.stepAppsureBankDetails.accountNumber',
    defaultMessage: 'Account Number',
  },
  accountNumberNZ: {
    id: 'fastCover.stepAppsureBankDetails.accountNumberNZ',
    defaultMessage: 'Account Number and Suffix',
  },
  accountNumberNZPlaceholder: {
    id: 'fastCover.stepAppsureBankDetails.accountNumberNZPlaceholder',
    defaultMessage: 'E.g. 1234567000',
  },
  bsbNumberNZTooltip: {
    id: 'fastCover.stepAppsureBankDetails.bsbNumberNZTooltip',
    defaultMessage:
      'The first 6 digits of your bank account which captures your bank’s prefix and branch number (e.g. 123113).',
  },
  accountNumberNZTooltip: {
    id: 'fastCover.stepAppsureBankDetails.accountNumberNZTooltip',
    defaultMessage: 'Your unique number and suffix (usually 9-10 digits)',
  },
  accountHolder: {
    id: 'fastCover.stepAppsureBankDetails.accountHolder',
    defaultMessage: 'Name Listed On Account',
  },
  accountNamePlaceholder: {
    id: 'fastCover.stepAppsureBankDetails.accountNamePlaceholder',
    defaultMessage: 'Account holder’s full name.',
  },
  GSTInfo: {
    id: 'fastCover.stepAppsureBankDetails.GSTInfo',
    defaultMessage: 'GST information - applicable if your policy was purchased for a business',
  },
  areYouRegisteredForGTSPurposes: {
    id: 'fastCover.stepAppsureBankDetails.areYouRegisteredForGTSPurposes',
    defaultMessage: 'Are you registered for GST Purposes?',
  },
  pleaseNote: {
    id: 'fastCover.stepAppsureBankDetails.pleaseNote',
    defaultMessage: 'Please note',
  },
  depositMessage: {
    id: 'fastCover.stepAppsureBankDetails.depositMessage',
    defaultMessage: 'If your claim is approved and where a cash settlement applies, we will deposit your settlement directly into your nominated bank account.',
  },
  bsbNumberLengthValidation: {
    id: 'fastCover.stepAppsureBankDetails.bsbNumberLengthValidation',
    defaultMessage: '{type} must be equal to 6 characters',
  },
  bsbCannotBeVerified: {
    id: 'fastCover.stepAppsureBankDetails.bsbCannotBeVerified',
    defaultMessage: 'BSB cannot be verified',
  },
  notice: {
    id: 'fastCover.stepAppsureBankDetails.notice',
    defaultMessage: 'The BSB Number you have entered could not be verified.',
  },
  noticeIntruction: {
    id: 'fastCover.stepAppsureBankDetails.noticeIntruction',
    defaultMessage: 'To continue any way, please tick the checkbox and manually enter the remaining fields.',
  },
  invalidBSBWarning: {
    id: 'fastCover.stepAppsureBankDetails.invalidBSBWarning',
    defaultMessage: 'The entered BSB number is not found in our records, tick the checkbox in order to successfully submit the claim.',
  },
  doYouHaveAnotherOtherInsurance: {
    id: 'fastCover.stepAppsureBankDetails.doYouHaveAnotherOtherInsurance',
    defaultMessage:
      'Do you have any other insurance that would cover all or part of your loss?',
  },
  exampleHomeContentsInsurance: {
    id: 'fastCover.stepAppsureBankDetails.exampleHomeContentsInsurance',
    defaultMessage:
      'e.g. Home Contents insurance, Private Health Fund, Credit Card',
  },
  ifYesPleaseProvideDetails: {
    id: 'fastCover.stepAppsureBankDetails.ifYesPleaseProvideDetails',
    defaultMessage: 'If yes, please provide details',
  },
  isRequired: {
    id: 'fastCover.stepAppsureBankDetails.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  noticeNZ: {
    id: 'fastCover.stepAppsureBankDetails.noticeNZ',
    defaultMessage: 'The Bank Code you have entered could not be verified.',
  },
  bsbNumberNZ: {
    id: 'fastCover.stepAppsureBankDetails.bsbNumberNZ',
    defaultMessage: 'Bank and Branch Code',
  },
  bsbNumberNZPlaceholder: {
    id: 'fastCover.stepAppsureBankDetails.bsbNumberNZPlaceholder',
    defaultMessage: 'E.g. 123456',
  },
  bsbCannotBeVerifiedNZ: {
    id: 'fastCover.stepAppsureBankDetails.bsbCannotBeVerifiedNZ',
    defaultMessage: 'Bank Code cannot be verified',
  },
  bankAccountNameTooltip: {
    id: 'fastCover.stepAppsureBankDetails.bankAccountNameTooltip',
    defaultMessage: 'The bank account holder\'s name.',
  },
  limitAccountNameCharacters: {
    id: 'fastCover.stepAppsureBankDetails.limitAccountNameCharacters',
    defaultMessage: 'The Name Listed On Account must be less than or equal to 32 characters',
  },
  onlyAlphaHyphenAllowed: {
    id: 'app.containers.StepAppsureBankDetails.onlyAlphaHyphenAllowed',
    defaultMessage: 'Only alphabetical characters and hyphens are allowed',
  },
  accountNumberLengthValidation: {
    id: 'app.containers.StepAppsureBankDetails.accountNumberLengthValidation',
    defaultMessage: 'The account number must not exceed {maxLength} digits.',
  },
  accountNumberLengthValidationWithSuffix: {
    id: 'app.containers.StepAppsureBankDetails.accountNumberLengthValidationWithSuffix',
    defaultMessage: 'Please enter your account number, including the suffix.',
  },
  accountNumberNZLengthValidationWithSuffix: {
    id: 'app.containers.StepAppsureBankDetails.accountNumberLengthValidationWithSuffix',
    defaultMessage: 'Your account number must contain 7 digits, and your suffix either 2 or 3 digits.',
  },
  accountHoldersName: {
    id: 'fastCover.stepAppsureBankDetails.accountHoldersName',
    defaultMessage: 'Account Holder’s Name',
  },
  onlyAlphaCharactersAllowed: {
    id: 'fastCover.stepAppsureBankDetails.onlyAlphaCharactersAllowed',
    defaultMessage: 'Only alphabetical characters are allowed.',
  },
  transitNumber: {
    id: 'fastCover.stepAppsureBankDetails.transitNumber',
    defaultMessage: 'Transit Number',
  },
  transitNumberValidation: {
    id: 'fastCover.stepAppsureBankDetails.transitNumberValidation',
    defaultMessage: 'Please enter the 5-digit Transit Number',
  },
  institutionNumber: {
    id: 'fastCover.stepAppsureBankDetails.institutionNumber',
    defaultMessage: 'Institution Number',
  },
  institutionNumberValidation: {
    id: 'fastCover.stepAppsureBankDetails.institutionNumberValidation',
    defaultMessage: 'Please enter the 3-digit Institution Number',
  },
  transitAndInstitutionCannotBeVerified: {
    id: 'fastCover.stepAppsureBankDetails.transitAndInstitutionCannotBeVerified',
    defaultMessage: 'Transit and Institution Number cannot be verified',
  },
  transitAndInstitutionNotice: {
    id: 'fastCover.stepAppsureBankDetails.transitAndInstitutionNotice',
    defaultMessage:
      'The Transit and Institution Number you have entered could not be verified. To continue anyway, please tick the checkbox and manually enter the remaining fields.',
  },
  accountNumberMinValidation: {
    id: 'fastCover.stepAppsureBankDetails.accountNumberMinValidation',
    defaultMessage: 'Please enter minimum of 7 digits.',
  },
  accountNumberMaxValidation: {
    id: 'fastCover.stepAppsureBankDetails.accountNumberMaxValidation',
    defaultMessage: 'Please enter maximum of 12 digits.',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Appsure.StepBankDetails/messages.js